var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3333 3.68316C25.65 2.99983 24.4667 3.46649 24.4667 4.41649V10.2332C24.4667 12.6665 26.5333 14.6832 29.05 14.6832C30.6333 14.6998 32.8333 14.6998 34.7167 14.6998C35.6667 14.6998 36.1667 13.5832 35.5 12.9165C33.1 10.4998 28.8 6.14983 26.3333 3.68316Z",
    fill: "#0C0D34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.1667 16.983H29.35C25.4 16.983 22.1834 13.7663 22.1834 9.81634V4.99967C22.1834 4.08301 21.4334 3.33301 20.5167 3.33301H13.45C8.31669 3.33301 4.16669 6.66634 4.16669 12.6163V27.383C4.16669 33.333 8.31669 36.6663 13.45 36.6663H26.55C31.6834 36.6663 35.8334 33.333 35.8334 27.383V18.6497C35.8334 17.733 35.0834 16.983 34.1667 16.983ZM19.1667 29.583H12.5C11.8167 29.583 11.25 29.0163 11.25 28.333C11.25 27.6497 11.8167 27.083 12.5 27.083H19.1667C19.85 27.083 20.4167 27.6497 20.4167 28.333C20.4167 29.0163 19.85 29.583 19.1667 29.583ZM22.5 22.9163H12.5C11.8167 22.9163 11.25 22.3497 11.25 21.6663C11.25 20.983 11.8167 20.4163 12.5 20.4163H22.5C23.1834 20.4163 23.75 20.983 23.75 21.6663C23.75 22.3497 23.1834 22.9163 22.5 22.9163Z",
    fill: "#0C0D34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.c97e8e7f3344dd85cb505ad7f469d246.svg";
export { ForwardRef as ReactComponent };